import $ from 'jquery';
import { Autoplay, EffectFade, FreeMode, Mousewheel, Navigation, Pagination, Swiper } from 'swiper';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

import { $Elements, Breakpoints, BrowserEvents, Classes, TransitionDurations } from './constants';

$Elements.document.on(BrowserEvents.page.enter, () => {

	// ---------- Manifest ----------

	$('.manifest-section .section-carousel').each(function() {

		if(!this.swiper) {

			const slider = new Swiper(this, {
				modules: [FreeMode, Mousewheel, Navigation, Pagination],
				loop: false,
				slidesPerView: 'auto',
				freeMode: true,
				speed: TransitionDurations.animations,
				observer: true,
				grabCursor: true,
				touchStartForcePreventDefault: true,
				mousewheel: {
					releaseOnEdges: true,
					forceToAxis: true,
				},
				pagination: {
					el: this.querySelector('.swiper-pagination'),
					type: 'progressbar',
				},
				navigation: {
					nextEl: this.querySelector('.swiper-button-next'),
					prevEl: this.querySelector('.swiper-button-prev'),
				},
				on: {
					init: (swiper) => {
						ScrollTrigger.refresh();
						$(this).find('.next-btn').click(() => swiper.slideNext());
					},
					snapIndexChange: (swiper) => {
						const pagination = $(this).find('.pagination .current');
						pagination.find('.item').removeClass(Classes.active);
						pagination.find('.item[data-slide="' + swiper.snapIndex + '"]').addClass(Classes.active);
					}
				}
			});
		}
	});

	// ---------- Carousel ----------

	$('.content-section .section-carousel, .content-section .column-carousel').each(function() {

		if(!this.swiper) {

			const swiper = new Swiper(this, {
				speed: TransitionDurations.default,
				loop: true,
				observer: true,
				modules: [Navigation, Pagination],
				pagination: {
					el: this.querySelector('.swiper-pagination'),
				},
				navigation: {
					nextEl: this.querySelector('.swiper-button-next'),
					prevEl: this.querySelector('.swiper-button-prev'),
				},
			});
		}
	});

	// ---------- Slideshow ----------

	$('.content-section .section-slideshow, .content-section .column-slideshow').each(function() {

		if(!this.swiper) {

			const swiper = new Swiper(this, {
				speed: TransitionDurations.default,
				loop: true,
				observer: true,
				autoplay: true,
				effect: 'fade',
				modules: [Autoplay, EffectFade, Navigation, Pagination],
				fadeEffect: {
					crossFade: true,
				},
				pagination: {
					el: this.querySelector('.swiper-pagination'),
				},
				navigation: {
					nextEl: this.querySelector('.swiper-button-next'),
					prevEl: this.querySelector('.swiper-button-prev'),
				},
			});
		}
	});
});
